'use strict';

var Actions = require('../actions/ZineServerActionCreators'),
    { get: get, del, put, post } = require('../utils/APIUtils');

var ZineAPI = {
  requestZine(zineSlug) {
    var url = `/api/zines/${zineSlug}`;
    get(url, Actions.handleZine, zineSlug);
  },

  createZine(zine) {
    var url = '/api/zines';
    post(url, zine, Actions.handleCreateZine, zine);
  },

  updateZine(zine) {
    var url = `/api/zines/${zine.slug}`;
    put(url, zine, Actions.handleUpdateZine, zine);
  },

  followZine(zineSlug) {
    var url = `/api/zines/${zineSlug}/subscriptions`;
    post(url, Actions.handleFollowZine, zineSlug);
  },

  unfollowZine(zineSlug) {
    var url = `/api/zines/${zineSlug}/subscriptions`;
    del(url, Actions.handleUnfollowZine, zineSlug);
  },

  deleteZine(zineSlug) {
    var url = `/api/zines/${zineSlug}`;
    del(url, Actions.handleDeleteZine, zineSlug);
  },

  submitStampToZine(zineSlug, stampSegment) {
    var url = `/api/zines/${zineSlug}/stamps/${stampSegment}`;
    put(url, Actions.handleSubmitStampToZine, zineSlug, stampSegment);
  },

  addStampToZine(zineSlug, stampSegment) {
    var url = `/api/zines/${zineSlug}/stamps/${stampSegment}`;
    put(url, Actions.handleAddStampToZine, zineSlug, stampSegment);
  },

  removeStampFromZine(zineSlug, stampSegment) {
    var url = `/api/zines/${zineSlug}/stamps/${stampSegment}`;
    del(url, Actions.handleRemoveStampFromZine, zineSlug, stampSegment);
  },

  approveStampToZine(zineSlug, stampSegment, message) {
    var url = `/api/zines/${zineSlug}/stamps/${stampSegment}/approve`;
    post(url, {
      message: message
    }, Actions.handleApproveStampToZine, zineSlug, stampSegment, message);
  },

  rejectStampFromZine(zineSlug, stampSegment, message) {
    var url = `/api/zines/${zineSlug}/stamps/${stampSegment}`;
    del(url, {
      message: message
    }, Actions.handleRejectStampFromZine, zineSlug, stampSegment, message);
  },

  requestZinesInSection(sectionId, url) {
    url = url || `/api/zines/sections/${sectionId}/zines`;
    get(url, Actions.handleRequestZinesInSection, sectionId);
  },

  requestZineSections(url) {
    url = url || '/api/zines/sections';
    get(url, Actions.handleRequestZineSections);
  },

  requestSuggestedPage(url) {
    url = url || '/api/zines/suggested';
    get(url, Actions.handleSuggestedPage);
  },

  requestUserCuratedPage(userId, url) {
    url = url || `/api/users/${userId}/zines/curated`;
    get(url, Actions.handleUserCuratedPage, userId);
  },

  requestUserCuratedUnlistedPage(userId, url) {
    url = url || `/api/users/${userId}/zines/curated/unlisted`;
    get(url, Actions.handleUserCuratedUnlistedPage, userId);
  },

  requestUserContributedPage(userId, url) {
    url = url || `/api/users/${userId}/zines/contributed`;
    get(url, Actions.handleUserContributedPage, userId);
  },

  requestUserContributedUnlistedPage(userId, url) {
    url = url || `/api/users/${userId}/zines/contributed/unlisted`;
    get(url, Actions.handleUserContributedUnlistedPage, userId);
  },

  requestSearchPage(terms, url) {
    url = url || `/api/zines/search?q=${window.encodeURIComponent(terms)}`;
    get(url, Actions.handleSearchPage, terms);
  }
};

module.exports = ZineAPI;


/** WEBPACK FOOTER **
 ** ./api/ZineAPI.js
 **/